import { render } from "./TabMainMarkets.vue?vue&type=template&id=69a6e6e0&scoped=true"
import script from "./TabMainMarkets.vue?vue&type=script&lang=js"
export * from "./TabMainMarkets.vue?vue&type=script&lang=js"

import "@/assets/scss/retail/tab-main-markets.scss?vue&type=style&index=0&id=69a6e6e0&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a6e6e0"]])

export default __exports__